import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { CheckCircle2 } from "lucide-react"
import { useNavigate } from "react-router"

export function InquiryDraftSuccessPage() {
  const { translate } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 bg-card p-8 text-center">
      <CheckCircle2 className="h-10 w-10 text-success" />
      <div className="flex flex-col gap-1.5">
        <div className="text-base font-semibold text-white">
          {translate("MC_INQ_DRAFT_SUCCESS_TITLE")}
        </div>
        <div className="text-sm text-grey5">
          {translate("MC_INQ_DRAFT_SUCCESS_BODY")}
        </div>
      </div>
      <Button
        className="bg-yellow1 text-black hover:bg-yellow2"
        onClick={() =>
          navigate("/material-compliance/supplier-studio/inquiry", {
            replace: true,
          })
        }
      >
        {translate("MC_INQ_DRAFT_SUCCESS_BTN")}
      </Button>
    </div>
  )
}
